import { useState } from "react";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import api from "../../api/axios";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="page-band">
      <Row className="justify-content-center">
        <Col md={7} lg={5}>
          <Card className="cardora-card">
            <Card.Body>
              <h1 className="section-title mb-3">Recuperar contraseña</h1>
              <p className="muted-copy">
                Escribe tu email y te enviaremos un enlace temporal para crear una nueva contraseña.
              </p>
              {sent && (
                <Alert variant="success" className="page-feedback">
                  Si el email está registrado, recibirás instrucciones en unos minutos.
                </Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="forgotEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    required
                  />
                </Form.Group>
                <Button type="submit" className="btn-cardora w-100" disabled={loading}>
                  {loading ? "Enviando..." : "Enviar enlace"}
                </Button>
              </Form>
              <p className="auth-legal-copy">
                <Link to="/login">Volver al login</Link>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;
